import { sessionStatusList } from '@/modules/status-list.js'
import { status, TRAINING_TYPE } from '@/main.config'
import { trainingDate } from '@/mixins/training-date.js'

export const trainingItem = {
  mixins: [trainingDate],
  components: {
    EventIcon: () => import('@/components/Training/EventIcon.vue'),
    CommentIcon: () => import('@/components/Training/CommentIcon.vue')
  },
  data: () => ({}),
  computed: {
    is6MWT() {
      return this.training.training_type === TRAINING_TYPE.sixmwt
    },
    isTrainingStandard() {
      return this.training.training_type === TRAINING_TYPE.base
    },
    isTrainingStatusPlan() {
      return this.training.status === status.plan
    },
    holdHRStr() {
      if (this.training.status < status.done) {
        if (!this.training.heart_rate_min && !this.training.heart_rate_max) {
          return '—'
        }
        return `${this.training.heart_rate_min}-${this.training.heart_rate_max}`
      } else if (this.training.status === status.done) {
        const holdHr = this.getHoldHRDoneTraining(this.training)
        return isNaN(holdHr) ? holdHr : `${holdHr}%`
      }
      return '—'
    }
  },
  methods: {
    getAverageHR(training) {
      if (training.status < status.done) {
        if (!training.heart_rate_min && !training.heart_rate_max) {
          return '—'
        }
        return training.heart_rate_min + '-' + training.heart_rate_max
      } else {
        if (!training.rhytmogram_avr_hr) {
          return '—'
        }
        return training.rhytmogram_avr_hr
      }
    },
    getHoldHRDoneTraining(training) {
      if (!training.efficiency) {
        return training.rhytmogram_zone_percent || '—'
      } else {
        return (training.efficiency * 100).toFixed(0)
      }
    },
    getStatusColor(training) {
      return training.status === status.done &&
        training.is_error_in_done_session &&
        training.training_type !== TRAINING_TYPE.sixmwt
        ? sessionStatusList[status.doneNotCorrectly].color
        : sessionStatusList[training.status].color
    },
    getStatusTitle(training) {
      return sessionStatusList[training.status].title
    },
    isStatusPlan(training) {
      return training.status === status.plan
    },
    getDistance(training) {
      if (!training.distance) {
        return ' — '
      }
      return training.distance + ` ${this.$t('unit.m')}`
    },
    /**
     * Можно удалять только запланированную тренировку, которая ззапланирована на дату позже текущей,
     * но если тренировка запланирована на сегодня и создана тоже сегодня, то тоже можно удалить
     * @param training
     * @returns {boolean}
     */
    isCanRemove(training) {
      if (!this.isStatusPlan(training)) {
        return false
      }
      const datePlan = this.getTrainingMomentStartDate(training)
      if (datePlan.isAfter(this.moment(), 'day')) {
        return true
      } else if (datePlan.isBefore(this.moment(), 'day')) {
        return false
      }
      const createdAt = this.getTrainingMomentCreatedDate(training)
      if (!createdAt) {
        return false
      }
      return createdAt.isSame(this.moment(), 'day')
    },
    isTodayDate(day) {
      let date = new Date().toLocaleDateString()
      return day == date
    },
    getFillColor(training, number) {
      return training.status == status.done && training.is_error_in_done_session === number
        ? '#FAAD14'
        : '#3F4156'
    },
    isTrain6MWT(training) {
      return training.training_type === TRAINING_TYPE.sixmwt
    }
  }
}
